import { Form } from "antd";
import { useParams } from "react-router";

import { CardDefinitionsTable } from "src/app/features/CardImplementation/subFeatures/CardDefinition/components/tables/CardDefinitionsTable";
import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { CreateTablePlaceholderComponent } from "../CreateTablePlaceholderComponent";

export const CardDefinitionsTableField: FieldMethod = ({ field }: FormFieldFactoryProps) => {
    // We use the id from the URL to determine if we are in a create or edit mode.
    const { id } = useParams();

    return id ? (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <CardDefinitionsTable key={field.name} />
        </Form.Item>
    ) : (
        <CreateTablePlaceholderComponent />
    );
};
